<template>
  <div class="special-service">
    <img
      class="close-btn"
      src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/common/icon-close.png"
      @click="confirmInfo"
    />
    <div class="content">
      <p class="title">预约专业顾问咨询</p>
      <p class="warm-tip">联系姓名</p>
      <input class="tel-input" maxlength="99" v-model.trim="form.name" />
      <p class="warm-tip">联系电话</p>
      <input
        class="tel-input"
        maxlength="11"
        v-model.trim="form.tel"
        @keyup="inputChange"
      />
      <p class="warm-tip">机构名称</p>
      <input class="tel-input" maxlength="99" v-model.trim="form.school_name" />
      <p class="warm-tip">机构地址</p>
      <input
        class="tel-input"
        maxlength="99"
        v-model.trim="form.area_name"
        @focus="areaShow = true"
      />
      <p class="warm-tip">选择您有意向的项目</p>
      <div class="radio-box radio-box-flex">
        <div class="radio-item">
          <input
            class="radio-input"
            type="radio"
            id="school_zero"
            :value="1"
            v-model="form.cooperations"
          />
          <label class="radio-label" for="school_zero">双师</label>
        </div>
        <div class="radio-item">
          <input
            class="radio-input"
            type="radio"
            id="school_one"
            :value="2"
            v-model="form.cooperations"
          />
          <label class="radio-label" for="school_one">AI</label>
        </div>
        <div class="radio-item">
          <input
            class="radio-input"
            type="radio"
            id="school_three"
            :value="3"
            v-model="form.cooperations"
          />
          <label class="radio-label" for="school_three">未来好课</label>
        </div>
        <div class="radio-item">
          <input
            class="radio-input"
            type="radio"
            id="school_twenty_two"
            :value="libuID"
            v-model="form.cooperations"
          />
          <label class="radio-label" for="school_twenty_two">励步</label>
        </div>
        <div class="radio-item">
          <input
            class="radio-input"
            type="radio"
            id="school_twenty_four"
            :value="24"
            v-model="form.cooperations"
          />
          <label class="radio-label" for="school_twenty_four">教研云</label>
        </div>
        <div class="radio-item" style="marginright: 26px">
          <input
            class="radio-input"
            type="radio"
            id="school_twenty_five"
            :value="25"
            v-model="form.cooperations"
          />
          <label class="radio-label" for="school_twenty_five">魔法学习机</label>
        </div>
      </div>
      <p class="warm-tip">
        您的机构是否具备从事学科培训业务的资格（营业执照/民办非企业单位登记证书和办学许可）
      </p>
      <div class="radio-box">
        <div class="radio-item">
          <input
            class="radio-input"
            type="radio"
            id="permission_yes"
            :value="1"
            v-model="form.permission"
          />
          <label class="radio-label" for="permission_yes">是</label>
        </div>
        <div class="radio-item">
          <input
            class="radio-input"
            type="radio"
            id="permission_no"
            :value="2"
            v-model="form.permission"
          />
          <label class="radio-label" for="permission_no">否</label>
        </div>
        <div class="radio-item">
          <input
            class="radio-input"
            type="radio"
            id="permission_3"
            :value="3"
            v-model="form.permission"
          />
          <label class="radio-label" for="permission_3"
            >办理中，半年内可获得</label
          >
        </div>
      </div>
      <textarea
        class="question-text"
        placeholder="问题描述：可以简单描述下您机构当前遇到的问题"
        v-model="form.description"
      ></textarea>
      <button class="submit-btn" @click="goPre">完成并预约</button>
    </div>
    <div class="success-info" v-if="isSuccess">
      <div class="info-box">
        <img
          class="icon-success"
          src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/common/icon-success.png"
        />
        <div class="detail">
          <p class="info-tip">
            老师，您好:<br />您的预约我们已经收到，请保持手机畅通，我们将在3天内安排专业顾问与您联系
          </p>
          <button class="confirm-btn" @click="confirmInfo">确定</button>
        </div>
      </div>
    </div>
    <van-popup v-model="areaShow" position="bottom">
      <van-area
        :area-list="areaList"
        :value="form.area_id"
        @confirm="onConfirm"
        @cancel="areaShow = false"
      />
    </van-popup>
  </div>
</template>
<script>
import vantArea from "../../../public/vant-area.js";
import authApi from "@/services/interface";
import { debounce } from "@/utils";
export default {
  data() {
    return {
      form: {
        name: "",
        tel: "",
        school_name: "",
        area_id: "",
        area_name: "",
        cooperations: "",
        permission: "",
        description: "",
      },
      areaList: vantArea,
      isSuccess: false,
      istelOk: true,
      areaShow: false,
      libuID: process.env.NODE_ENV === "production" ? "22" : "22",
    };
  },
  mounted() {
    this.debounceSub = debounce(this.submitData, 500);
  },
  methods: {
    init() {
      this.form = {
        name: "",
        tel: "",
        school_name: "",
        area_id: "",
        area_name: "",
        cooperations: "",
        permission: "",
        description: "",
      };
      this.isSuccess = false;
      this.istelOk = true;
    },
    onConfirm(vals) {
      this.form.area_name = vals
        .filter((item) => !!item)
        .map((item) => item.name)
        .join("/");
      this.form.area_id = vals.filter((item) => !!item).pop().code;
      this.areaShow = false;
    },
    inputChange(e) {
      e.target.value = e.target.value.replace(/[^0-9]/g, "");
    },
    goPre() {
      if (this.validate()) {
        this.debounceSub();
      }
    },
    submitData() {
      delete this.form.area_name;
      authApi.register(this.form).then((res) => {
        if (res.ok) {
          this.isSuccess = true;
        } else {
          this.$toast(res.message);
        }
      });
    },
    validate() {
      if (!this.form.name) {
        this.$toast("请输入姓名");
        return false;
      }
      if (!this.form.tel) {
        this.istelOk = false;
        this.$toast("请输入手机号");
        return false;
      } else if (this.form.tel.length !== 11) {
        this.istelOk = false;
        this.$toast("请输入11位手机号");
        return false;
      }
      if (!this.form.school_name) {
        this.$toast("请输入机构名称");
        return false;
      }
      if (!this.form.area_id) {
        this.$toast("请选择地区");
        return false;
      }
      if (!this.form.cooperations) {
        this.$toast("请选择有意向的项目");
        return false;
      }
      if (!this.form.permission) {
        this.$toast("请选择从事资格");
        return false;
      }
      this.istelOk = true;
      return true;
    },
    confirmInfo() {
      this.init();
      this.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
.special-service {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  z-index: 1000;
  padding-top: 50px;
  padding-bottom: 20px;
  background: #ffffff;
  overflow-y: auto;
  .close-btn {
    position: absolute;
    width: 18px;
    height: 18px;
    right: 23px;
    top: 16px;
  }
  .content {
    // width: 100%;
    // height: 100%;
    background: #ffffff;
    padding: 14px 20px;
    text-align: left;
    .title {
      text-align: center;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #272727;
      line-height: 25px;
      margin-bottom: 20px;
    }
    .warm-tip {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #272727;
      line-height: 17px;
    }
    .tel-input {
      width: 100%;
      height: 44px;
      background: rgba(255, 255, 255, 1);
      border-radius: 3px;
      border: 1px solid #dadada;
      margin: 10px 0px 20px;
      padding: 0px 12px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #272727;
      line-height: 17px;
      outline: none;
      -webkit-appearance: none; /*去除系统默认的样式*/
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /* 点击高亮的颜色*/
      box-shadow: none;
      &:focus {
        border: 1px solid #fb594a;
      }
      &::placeholder {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 17px;
      }
    }
    .radio-box {
      margin: 12px 0px 32px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(39, 39, 39, 1);
      line-height: 20px;
      .radio-item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 30px;
        .radio-input {
          margin: 0px 5px 0px 0px;
          position: relative;
          appearance: none;
          outline: none;
          padding-left: 14px;
          &:before {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            content: "";
            width: 14px;
            height: 14px;
            border: 0px;
            border-radius: 50%;
            background: url("https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/common/icon-unselect.png");
            background-size: 100% 100%;
          }
          &:checked:before {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            content: "";
            width: 14px;
            height: 14px;
            border: 0px;
            background: url("https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/common/icon-selected.png");
            background-size: 100% 100%;
            border-radius: 50%;
          }
        }
        &:last-of-type {
          margin-right: 0px;
        }
      }
    }
    .radio-box-flex {
      .radio-item {
        min-width: 85px;
        margin-right: 23px;
        margin-bottom: 12px;
      }
    }
    .question-text {
      width: 100%;
      height: 100px;
      // margin-top: 14px;
      border: 1px solid #dadada;
      border-radius: 3px;
      padding: 12px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #272727;
      line-height: 17px;
      outline: none;
      -webkit-appearance: none; /*去除系统默认的样式*/
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /* 点击高亮的颜色*/
      &:focus {
        border: 1px solid #fb594a;
      }
      &::placeholder {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 17px;
      }
    }
    .submit-btn {
      margin-top: 18px;
      width: 100%;
      height: 44px;
      background: rgba(251, 89, 74, 1);
      border-radius: 3px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      border: 0px;
      outline: none;
    }
  }
  .success-info {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    background: rgba(0, 0, 0, 0.3);
    z-index: 1001;
    .info-box {
      width: 255px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #ffffff;
      border-radius: 8px;
      .icon-success {
        width: 100%;
      }
      .detail {
        text-align: left;
        padding: 10px 14px;
        .info-tip {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
          line-height: 17px;
        }
        .confirm-btn {
          display: block;
          margin: 10px auto 0px;
          width: 180px;
          height: 38px;
          background: #fb594a;
          border-radius: 3px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          border: 0;
          outline: 0;
        }
      }
    }
  }
}
</style>